// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef, useState } from 'react'
import './filePopUpContainer.scss'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorAlert, FilePopUp, PageLoadingSpinner } from 'ui_kit_qmd'
import { setMediaFileTags } from '../../store/file-pop-up/FilePopUpThunk'
import { getTabId, parseTimeZone, parseUserDateTime } from '../../utils/common'
import FilePopUpListener from '../../store/file-pop-up/FilePopUpListener'
import errorIcon from '../../images/common/error-icon.svg'
import { apiCall } from '../../utils/restclient'

const FilePopUpContainer = () => {
  const patientId = useRef('')
  const fileId = useRef('')
  const stateCode = useRef('')
  const dispatch = useDispatch()
  const tabId = getTabId()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)

  const [showFilePopUp, setShowFilePopUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [userTimeZone, setUserTimeZone] = useState(parseTimeZone(profile?.TimeZone))
  const [drugMediaFile, setDrugMediaFile] = useState({})

  useEffect(() => {
    if (profile?.TimeZone) {
      setUserTimeZone(parseTimeZone(profile?.TimeZone))
    }
  }, [profile])

  const updateFile = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (file) => {
      setDrugMediaFile({ ...drugMediaFile, ...file })
    },
    [drugMediaFile],
  )

  const getMediaFileSuccess = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (file, openedPatientId, openedFileId, openedStateCode) => {
      patientId.current = openedPatientId
      fileId.current = openedFileId
      stateCode.current = openedStateCode
      setDrugMediaFile(file)
      setShowFilePopUp(true)
    },
    [setShowFilePopUp],
  )

  const closeFilePopUp = useCallback(() => {
    patientId.current = ''
    fileId.current = ''
    stateCode.current = ''
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setError('')
    setShowFilePopUp(false)
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setToastMessage = useCallback((value) => {
    setError(value)
    setTimeout(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setError('')
    }, 3500)
  }, [])

  return (
    <>
      {loading ?
        <PageLoadingSpinner />
      : null}
      <FilePopUpListener
        onUpdateFile={updateFile}
        onSetLoading={setLoading}
        setToastMessage={setToastMessage}
        tabId={tabId}
        onGetMediaFileSuccess={getMediaFileSuccess}
        onCloseFilePopUp={closeFilePopUp}
        patientId={patientId.current}
        fileId={fileId.current}
        stateCode={stateCode.current}
      />
      {showFilePopUp ?
        <FilePopUp
          {...drugMediaFile}
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setMediaFileTags={(mediaFile) => {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            dispatch(setMediaFileTags(mediaFile, tabId))
          }}
          apiCall={apiCall}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          dateTimeString={parseUserDateTime(drugMediaFile.UploadDateTime, userTimeZone, false)}
          setToastErrorMessage={setToastMessage}
          closePopUp={closeFilePopUp}
        />
      : null}
      {error ?
        <div className='file-pop-up-error-container'>
          <ErrorAlert errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}
    </>
  )
}

export default FilePopUpContainer
